/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../molecules/teaser/css/teaser';
import './segment-teaser.scss';
import './modifier/inline.scss';
